
(function( $ ) {
    $.extend($.expr[':'], {
        'containsi': function(elem, i, match, array) {
          return (elem.textContent || elem.innerText || '').toLowerCase()
              .indexOf((match[3] || "").toLowerCase()) >= 0;
        }
    });

    $('.search-button').click(function(){
        $('.artist-search-modal').fadeIn();
    });

    $('.artist-search-close').click(function(){
        $('.artist-search-modal').fadeOut();
    });

    $('.artist-search-input').keyup(function(){
        let val = $(this).val();
        if(val.length > 0) {
            $('.artist-search-modal .list').show();
            $('.artist-search-modal .list div').hide();
            
            $('.artist-search-modal .list div:containsi('+ val.toLowerCase() +'):lt(10)').show();
        } else {
            $('.artist-search-modal .list').hide();
        }
    });
  })(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partial/search.js